module.exports = __webpack_public_path__ + "img/936-84521f.png";